const Index = r => require.ensure([], () => r(require('./Index')), 'group-share')
const Registered = r => require.ensure([], () => r(require('./Registered')), 'group-share-Registered')
const ArticleDetails = r => require.ensure([], () => r(require('./ArticleDetails')), 'group-share-ArticleDetails')
const ArticleDetailsRecommend = r => require.ensure([], () => r(require('./ArticleDetailsRecommend')), 'group-share-ArticleDetailsRecommend')
const ConsultantDetails = r => require.ensure([], () => r(require('./ConsultantDetails')), 'group-share-ConsultantDetails')
const LessonDetails = r => require.ensure([], () => r(require('./LessonDetails')), 'group-share-LessonDetails')
const LessonDetailsCatalog = r => require.ensure([], () => r(require('./LessonDetailsChildren/Catalog')), 'group-share-LessonDetails')
const LessonDetailsGeneral = r => require.ensure([], () => r(require('./LessonDetailsChildren/General')), 'group-share-LessonDetails')
const LessonDetailsGrade = r => require.ensure([], () => r(require('./LessonDetailsChildren/Grade')), 'group-share-LessonDetails')
const SuccessCaseDetails = r => require.ensure([], () => r(require('./SuccessCaseDetails')), 'group-share-SuccessCaseDetails')
const ServerDetails = r => require.ensure([], () => r(require('./ServerDetails')), 'group-share-ServerDetails')
const ServerDetailsRecommend = r => require.ensure([], () => r(require('./ServerDetailsRecommend')), 'group-share-ServerDetailsRecommend')
const SchoolDetails = r => require.ensure([], () => r(require('./SchoolDetails')), 'group-share-SchoolDetails')
const CounselorList = r => require.ensure([], () => r(require('./CounselorList')), 'group-share-SchoolDetails')
const SchoolSuccessCase = r => require.ensure([], () => r(require('./SchoolSuccessCase')), 'group-share-SchoolSuccessCase')
const SchoolNotice = r => require.ensure([], () => r(require('./SchoolNotice')), 'group-share-SchoolNotice')
const SchoolNoticeDetails = r => require.ensure([], () => r(require('./SchoolNotice/SchoolNoticeDetails')), 'group-share-SchoolNoticeDetails')
const SchoolNoticeDetails4SC = r => require.ensure([], () => r(require('./SchoolNoticeDetails4SC')), 'group-share-SchoolNoticeDetails')
const SchoolTraining = r => require.ensure([], () => r(require('./SchoolTraining')), 'group-share-SchoolTraining')
const QuestionAnswer = r => require.ensure([], () => r(require('./QuestionAnswer')), 'group-share-QuestionAnswer')
const ChoiceResult = r => require.ensure([], () => r(require('./ChoiceResult')), 'group-share-ChoiceResult')
const ProfessionalList = r => require.ensure([], () => r(require('./ProfessionalList')), 'group-share-ProfessionalList')
const MoreProfession = r => require.ensure([], () => r(require('./MoreProfession')), 'group-share-MoreProfession')
const SchoolIntroduction = r => require.ensure([], () => r(require('./SchoolIntroduction')), 'group-share-SchoolIntroduction')
const Boshuoben = r => require.ensure([], () => r(require('./chilren-stage/Boshuoben')), 'group-share-Boshuoben')
const LanguageClass = r => require.ensure([], () => r(require('./chilren-stage/LanguageClass')), 'group-share-LanguageClass')
const Yuke = r => require.ensure([], () => r(require('./chilren-stage/Yuke')), 'group-share-Yuke')
const Zhongxue = r => require.ensure([], () => r(require('./chilren-stage/Zhongxue')), 'group-share-Zhongxue')
const RefundIntrodution = r => require.ensure([], () => r(require('./RefundIntroduction')), 'refund-operation-Introduction')
const ldy20220602 = r => require.ensure([], () => r(require('./20220602ldy')), 'ldy')
export default {//
  path: '/share',
  component: Index,
  children: [
    {
      path: 'registered',
      name: 'Registered',
      component: Registered
    },
    {// isApp=false&articleId=25725&cid=G003125&random=4eea91f62c45cf4845bd9db04ea7a565
      path: 'choice-result',
      name: 'ChoiceResult',
      component: ChoiceResult
    },
    {// isApp=false&articleId=25725&cid=G003125&random=4eea91f62c45cf4845bd9db04ea7a565
      path: 'article-details',
      name: 'ArticleDetails',
      component: ArticleDetails
    },
    {// isApp=false&articleId=25725&cid=G003125&random=4eea91f62c45cf4845bd9db04ea7a565
      path: 'article-details-recommend',
      name: 'ArticleDetailsRecommend',
      component: ArticleDetailsRecommend
    },
    {// cid=G002212&fid=G003125&r=54f6ee8e9829ba2560d7e2722e2e7362
      path: 'consultant-details',
      name: 'shareConsultantDetails',
      component: ConsultantDetails
    },
    {// trainId=55&f=G003125&r=54f6ee8e9829ba2560d7e2722e2e7362
      path: 'lesson-details',
      component: LessonDetails,
      children: [
        {
          path: '',
          redirect: 'general',
          meta: {
            isLogin: true,
            title: '课程详情'
          }
        },
        {
          path: 'general',
          name: 'general',
          component: LessonDetailsGeneral,
          meta: {
            header: true,
            footer: true,
            isLogin: true,
            title: '课程详情'
          }
        },
        {
          path: 'catalog',
          name: 'catalog',
          component: LessonDetailsCatalog,
          meta: {
            header: true,
            footer: true,
            isLogin: true,
            title: '课程详情'
          }
        },
        {
          path: 'grade',
          name: 'grade',
          component: LessonDetailsGrade,
          meta: {
            header: true,
            footer: true,
            isLogin: true,
            title: '课程详情'
          }
        }
      ]
    },
    {// caseid=3097&cid=G003125&random=59f73db7ce3145be37a573f2a263de60
      path: 'success-case-details',
      name: 'SuccessCaseDetails',
      component: SuccessCaseDetails
    },
    {// server-details/155/5
      path: 'server-details/:id/:type',
      name: 'ServerDetails',
      component: ServerDetails
    },
    {
      path: 'server-detail-recommend/:id/:type',
      name: 'server-detail-recommend',
      component: ServerDetailsRecommend
    },
    {
      path: 'school-details',
      name: 'SchoolDetails',
      component: SchoolDetails
    },
    {
      path: 'counselor-list',
      name: 'CounselorList',
      component: CounselorList
    },
    {
      path: 'school-success-case',
      name: 'school-success-case',
      component: SchoolSuccessCase
    },
    {
      path: 'school-notice',
      name: 'school-notice',
      component: SchoolNotice
    },
    {
      path: 'school-notice-details',
      name: 'school-notice-details',
      component: SchoolNoticeDetails
    },
    {
      path: 'school-notice-details-4sc',
      name: 'school-notice-details-4sc',
      component: SchoolNoticeDetails4SC
    },
    {
      path: 'school-training',
      name: 'school-training',
      component: SchoolTraining
    },
    {
      path: 'question-answer',
      name: 'QuestionAnswer',
      component: QuestionAnswer
    },
    {
      path: 'professional-list',
      name: 'ProfessionalList',
      component: ProfessionalList
    },
    {
      name: 'MoreProfession',
      path: 'more-profession',
      component: MoreProfession
    }, {
      path: 'school-introduction',
      name: 'SchoolIntroduction',
      component: SchoolIntroduction
    },
    {
      name: 'Boshuoben',
      path: 'stage/boshuoben',
      component: Boshuoben,
      meta: {
        title: '博士、硕士、本科分享'
      }
    },
    {
      name: 'LanguageClass',
      path: 'stage/languageclass',
      component: LanguageClass,
      meta: {
        title: '语言班分享'
      }
    },
    {
      name: 'Yuke',
      path: 'stage/yuke',
      component: Yuke,
      meta: {
        title: '预科分享'
      }
    },
    {
      name: 'Zhongxue',
      path: 'stage/zhongxue',
      component: Zhongxue,
      meta: {
        title: '中学分享'
      }
    },
    {
      name: 'RefundIntrodution',
      path: 'refund-introduction',
      component: RefundIntrodution,
      meta: {
        title: '退费操作说明'
      }
    },
    {
      name: 'ldy20220602',
      path: 'ldy20220602',
      component: ldy20220602,
      meta: {
        title: '邀请好友办留学'
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/share/router.js